// src/components/layout/topbar/LogoutPage.jsx
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout as logoutAction } from "../../../store/slices/authSlice";
import { clearTenant } from "../../../store/slices/tenantSlice";
import { clearPermissions } from "../../../store/slices/permissionSlice"; // ✅ add

function LogoutPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onLogout = () => {
    // ✅ clear tenant selection
    dispatch(clearTenant());

    // ✅ clear permissions (prevents stale role/tenant permission cache)
    dispatch(clearPermissions());

    // ✅ clear auth (token/user + user_role/user_id if you added in authSlice)
    dispatch(logoutAction());

    // OPTIONAL: clear tenant filters too
    localStorage.removeItem("tenant_dist_id");
    localStorage.removeItem("tenant_taluk_id");

    // ✅ important: prevent back-navigation to protected pages
    navigate("/login", { replace: true });
  };

  return (
    <button className="dropdown-item ai-icon ms-1 logout-btn" onClick={onLogout}>
      Logout
    </button>
  );
}

export default LogoutPage;
